import React from 'react';

/**
 * props:
 * - id
 * - label
 * - type
 * - placeholder
 * - icon
 * - autoFocus
 * - required
 * - onChange
 */
function AuthField(props) {
  return (
    <div className="auth-field">
      <label htmlFor={props.id}>{props.label}</label>
      <div className="auth-input-wrap">
        {props.icon && <span className="auth-input-icon">{props.icon}</span>}
        <input
          id={props.id}
          type={props.type || 'text'}
          placeholder={props.placeholder}
          autoFocus={props.autoFocus}
          required={props.required !== false}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
}

export default AuthField;